module.exports = __webpack_public_path__ + "img/75625.2eaeb892.svg";